/**
 * Resumen clínico y vista pública (QR).
 */
// --- Resumen clínico (público / QR veterinario) ---
export const clinicalSummary = {
  noMedicalDataMessage: 'No hay registros médicos para generar el resumen clínico.',
  noMedicalDataToast: 'No hay suficiente información médica para generar un resumen clínico.',
} as const;

// --- Vista pública por QR (PublicPetContent, PublicPetHeader, PublicPetPage) ---
export const publicPet = {
  basicInfo: 'Información básica',
  approximateAge: 'Edad aproximada',
  biographyTitle: 'Biografía de mi mascota',
  generalNotes: 'Notas generales',
  medicalInfoTitle: 'Información médica relevante',
  medicalConditions: 'Condiciones médicas',
  filterByYear: 'Filtrar información por año',
  filterByYearHint: 'Selecciona un año para ver controles médicos, vacunaciones y peluquerías de ese período',
  yearLabel: 'Año:',
  allYears: 'Todos los años',
  statsTitle: 'Estadísticas médicas',
  controlsCount: 'Controles médicos',
  vaccinesApplied: 'Vacunas aplicadas',
  contactAndEmergencies: 'Contacto y emergencias',
  emergencyContact: 'Contacto de emergencia',
  veterinarianContact: 'Veterinario tratante',
  noEmergencyContacts: 'No se registraron contactos de emergencia. Solicite al tutor actualizar esta sección.',
  digitalRecord: 'Ficha digital',
  tutorInfo: 'Información del tutor',
  identification: 'Identificación:',
  associatedClinic: 'Clínica asociada',
  address: 'Dirección:',
  phone: 'Teléfono:',
  lastFollowUps: 'Últimos seguimientos',
  lastControl: 'Último control:',
  currentStatus: 'Estado actual:',
  noRecentControls: 'No hay controles recientes registrados.',
  recentSurgeries: 'Cirugías recientes',
  summaryCurrent: 'Resumen actual:',
  withMicrochip: 'Con microchip',
  scanAndRegister: 'Escanea y registra la información más reciente de',
  generatingSummary: 'Generando resumen...',
  generatingShort: 'Generando...',
  regenerateClinicalSummary: 'Regenerar resumen clínico',
  verifying: 'Verificando...',
  addMedicalControl: 'Agregar control médico',
  addControlShort: 'Agregar control',
  editControlOnce: 'Editar control (1 vez)',
  editControlShort: 'Editar control',
  editTimeExpired: 'El tiempo para editar este control ha expirado.',
  editUsed: 'Edición única utilizada.',
  ownerLabel: 'Dueño:',
  phoneLabel: 'Teléfono:',
  petNotFound: 'Mascota no encontrada',
  accessExpired: 'Acceso caducado',
  linkExpiredMessage: 'El enlace temporal para esta ficha ya no es válido. Vuelve a escanear el código QR para obtener un nuevo acceso.',
  author: '',
  systemName: 'Sistema de Fichas Veterinarias Digitales',
  cannotUseClinicalSummary: 'No puedes usar la función de resumen clínico en este momento.',
  generateSummaryError: 'No se pudo generar el resumen. Por favor, recarga la página.',
} as const;
